import { render, staticRenderFns } from "./watch.vue?vue&type=template&id=4bb7a1a4&scoped=true"
import script from "./watch.vue?vue&type=script&lang=js"
export * from "./watch.vue?vue&type=script&lang=js"
import style0 from "./watch.vue?vue&type=style&index=0&id=4bb7a1a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb7a1a4",
  null
  
)

export default component.exports